var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button } from "../Button";
import Icon from "../Icon";
import React, { useRef, useState } from 'react';
import { css, styled } from "../../utils";
import Input, { InputProps } from "./Input";
var ToggleButton = styled(Button)(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    svg {\n      width: 35px;\n      height: 35px;\n      margin: 0;\n\n      path {\n        fill: none !important;\n      }\n\n      &:hover {\n        fill: none !important;\n\n        path,\n        circle {\n          stroke: ", ";\n        }\n      }\n    }\n  "], ["\n    svg {\n      width: 35px;\n      height: 35px;\n      margin: 0;\n\n      path {\n        fill: none !important;\n      }\n\n      &:hover {\n        fill: none !important;\n\n        path,\n        circle {\n          stroke: ", ";\n        }\n      }\n    }\n  "])), colors.primary);
});
var Password = function (_a) {
    var props = __rest(_a, []);
    var inputRef = useRef(null);
    var _b = useState(false), togglePassword = _b[0], setTogglePassword = _b[1];
    var handlePasswordToggle = function () { return setTogglePassword(!togglePassword); };
    return (React.createElement(Input, __assign({}, props, { "data-component": "Password", ref: inputRef, name: props.name || 'password', type: togglePassword ? 'text' : 'password', suffix: props.value && (React.createElement(ToggleButton, { ghost: true, type: "button", onClick: handlePasswordToggle, style: { zIndex: 99 } }, togglePassword ? React.createElement(Icon.EyeOff, null) : React.createElement(Icon.EyeOn, null))) })));
};
export default Password;
var templateObject_1;
//# sourceMappingURL=Password.js.map